<div class="ump_mersy_kpi_group_function">
  <div class="row heading-background mt-5">

    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
      <h4 (click)="showData ? hideData() : resetAll()"
        role="button"
        class="clickable-cursor">
        <span [ngClass]="showData ? 'rotated' : 'not-rotated'">
          <mat-icon class="icon-color-fix ump-expand-section-icon">chevron_right</mat-icon>
        </span>
        Mersy KPI Group Function
      </h4>
    </div>

    @if (showData) {
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 search-container">
        <input class="form-control" name="searchString" [(ngModel)]="searchString" type="text" (keyup)="treeControl.expandAll()" placeholder="Search" />
        <mat-slide-toggle matTooltip="Show only selected" class="toggle-show-only-selected" [(ngModel)]="showOnlySelected"></mat-slide-toggle>
        <button aria-label="Collapse All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.collapseAll()">
          <mat-icon class="icon-color-fix">unfold_less</mat-icon>
        </button>
        <button aria-label="Expand All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.expandAll()">
          <mat-icon class="icon-color-fix">unfold_more</mat-icon>
        </button>
      </div>
    }
  </div>

  @if (showData) {
    <div class="custom_small_panelbody_fix">
      @if (Tree_Response_State=== 1) {
        <div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-nested-tree-node class="mat-tree-node" *matTreeNodeDef="let node"
              matTreeNodeToggle
              [style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) ? 'none' : 'block'">
              <li class="mat-tree-node">
                <mat-checkbox class="checklist-leaf-node" (change)="itemToggle($event.checked,node, true)" [disabled]="node.disabled ||   !node.canAssign " [checked]="node.selected">{{node.text}} </mat-checkbox>
              </li>
            </mat-nested-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
              [style.display]="(showOnlySelected && !(node.selected || node.indeterminate)) || this.searchString && hideParentNode(node) ? 'none' : 'block'">
              <li>
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.text">
                    <mat-icon class="mat-icon-rtl-mirror icon-color-fix">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="node.selected" [disabled]="node.disabled  || !node.canAssign "
                    [indeterminate]="node.indeterminate && !node.selected"
                  (change)="itemToggle($event.checked,node, true)">{{node.text}}</mat-checkbox>
                </div>
                <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      }
      @if (Tree_Response_State===-2) {
        <div style=" padding: 20px !important;">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(4); track $index) {
              <div class="card__desc-text"></div>
            }
          </div>
        </div>
      }
    </div>
  }

</div>